import {baseAxios} from '../helper/axiosHelper';

export const pollingService = {
    getPublicBanners,
    getPrivateBanners
};

function getPublicBanners() {

    return baseAxios.get('polling/banners/public')
    .then((response) =>
    {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}

function getPrivateBanners() {

    return baseAxios.get('polling/banners/private')
    .then((response) =>
    {
        return response.data;
    })
    .catch(function (error) {
        return error;
    });
}